import { useState } from 'react';
import Button from '@mui/material/Button';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import { useAppDispatch } from '../../../../redux/store/store';
import { authorizedUserAction } from '../../../../redux/authorizedUsers/authorizedUsers.actions';

export default function RemoveUser (props: any) {

    // Component Props
    const { id, open, setAlert, showAlert, handleModalClose } = props;
    console.log("🚀 ~ RemoveUser ~ id:", id)
    
    // hooks
    const dispatch = useAppDispatch();

    // handle Remove Customer User Function
      const handleRemoveUser = (id: string) => {
        // Payload For The API Call
        const payload = {
          id,
        };
    
      // API Call For Remove Customer User
      dispatch(authorizedUserAction.removeCustomerUserAction(payload))
        .then((res: any) => {
    
          const status = res?.payload?.data?.status;
          const message = res?.payload?.data?.message;
    
          if (status === 200) {
              setAlert({
                  message: message || "User removed successfully.",
              type: "success",
              show: true,
            });
            // close modal
            handleModalClose();
            //get Updated Details
            dispatch(authorizedUserAction.getCustomerUsersAction(payload));
          } else {
            setAlert({
              message: message || "Failed to remove user.",
              type: "error",
              show: true,
            });
          }
        })
        .catch((err: any) => {
          console.log("err", err);
          setAlert({
            message: err?.message || "Failed to remove user. Please try again.",
            type: "error",
            show: true,
          });
        });
    
      };

      return (
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="custom-modal-wrap modal-terms-condition modal-accept-all"
            >
                <Box className="modal-content modal-content-remove-model">
                        <div className="modal-header text-center">
                            <h2>Remove Authorized User?</h2>
                            <p>Are you sure you want to remove this user? Once removed, they will no <br />longer have access to your client portal account.</p>
                        </div>
                    <div className="mid-content">
                        <div className="box-style">
    
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <div className="button-wrap text-center">
                            <Button 
                                className='btn-cancel' 
                                onClick={handleModalClose}
                            >
                                Cancel
                            </Button>
                            <Button 
                                className='btn-accept-all'
                                onClick={() => handleRemoveUser(id)}
                            >
                                Remove
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
        )
}